import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, scrollToId } from "@/lib/api";
import { openInstall } from "@/lib/install";
import { Reveal } from "./Reveal";
import { LogoMark } from "./Logo";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/subscribers", { email });
      toast.success(data?.already ? "You're already on the list." : "You're on the list. First to know.");
      setEmail("");
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <section data-testid="newsletter-section" className="bg-[#56ED4A] text-black px-5 md:px-10 py-20 md:py-28">
      <Reveal className="grid lg:grid-cols-2 gap-10 items-end">
        <h2 className="font-display uppercase text-6xl md:text-8xl leading-[0.85]">Get on<br />the list.</h2>
        <form onSubmit={submit} className="flex border-b-2 border-black" data-testid="newsletter-form">
          <input data-testid="newsletter-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" className="flex-1 min-w-0 bg-transparent py-4 text-xl md:text-2xl placeholder:text-black/50 outline-none" />
          <button data-testid="newsletter-submit-btn" aria-label="Subscribe" className="px-4 hover:translate-x-1 transition-transform"><ArrowRight size={32} /></button>
        </form>
      </Reveal>
    </section>
  );
};

export const Footer = () => (
  <footer data-testid="site-footer" className="px-5 md:px-10 pt-20 pb-8 overflow-hidden">
    <div className="flex flex-col md:flex-row justify-between gap-10">
      <div className="flex items-center gap-4"><LogoMark className="w-20 h-20" /><p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 max-w-[220px]">Promoter · Shows · Brand collective</p></div>
      <div className="flex flex-wrap gap-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-300">
        {[["shows", "Shows"], ["crew", "Crew"], ["vip", "VIP"], ["merch", "Booking"]].map(([id, l]) => (
          <button key={id} data-testid={`footer-${id}-link`} onClick={() => scrollToId(id)} className="hover:text-[#56ED4A]">{l}</button>
        ))}
        <button data-testid="footer-get-app-btn" onClick={openInstall} className="text-[#56ED4A] hover:underline">Get the App</button>
        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#56ED4A]">Admin</Link>
      </div>
    </div>
    <p className="font-display uppercase text-[22vw] leading-[0.9] mt-16 chrome-text select-none">JayPanduh</p>
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 mt-6">© {new Date().getFullYear()} JayPanduh. All rights reserved.</p>
  </footer>
);
